import * as UserModels from '../../models/user/user';
import * as Models from '../../models/commonModels';

export class GetGuardianDictionary {
  static readonly type = '[User] Guardian Dictionary';
  constructor() { }
}

export class SetContextUser {
  static readonly type = '[User] SetCustomer';
  constructor(public User: UserModels.User) { }
}

export class ResetSave {
  static readonly type = '[User] ResteSave';
  constructor() { }
}

export class GetList {
  static readonly type = '[User] List';
  constructor(public Search: UserModels.UserSearchModel) { }
}

export class SetSearch {
  static readonly type = '[User] Set Search';
  constructor(public Search: UserModels.UserSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[User] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[User] Set List Page';
  constructor(public Search: UserModels.UserSearchModel) { }
}

export class Create {
  static readonly type = '[User] Create';
  constructor(public User: Models.Request<UserModels.UserEditModel>) { }
}

export class Get {
  static readonly type = '[User] Get';
  constructor(public UserID: Models.RequestModel) { }
}

export class Set {
  static readonly type = '[User] Set';
  constructor(public User: Models.Request<UserModels.UserEditModel>) { }
}

export class SetPreview {
  static readonly type = '[User] Set Preview';
  constructor(public User: Models.Request<UserModels.UserPreviewListModel>) { }
}

export class Remove {
  static readonly type = '[User] Remove';
  constructor(public UserID: Models.RequestModel) { }
}